import React, { useMemo } from 'react'

export type WordShuffleProps = {
  children: string
  onShuffleEnd?: () => void
}

const LETTERS = 'abcdefghijklmnopqrstuvwxyz0123456789'
const getNRandomLetters = (n: number) => {
  const result = []

  for (let i = 0; i < n; i++) {
    const randomIndex = Math.floor(Math.random() * LETTERS.length)
    result.push(LETTERS[randomIndex])
  }

  return result
}

export const WordShuffle: React.FC<WordShuffleProps> = ({ onShuffleEnd, children }) => {
  const [_, setIsShuffled] = React.useState<Set<number>>(new Set())
  const letters = children.split('')

  return letters.map((letter, index) => {
    return (
      <Letter
        key={index}
        onShuffleEnd={() => {
          setIsShuffled((prev) => {
            prev.add(index)
            if (prev.size === letters.length) {
              onShuffleEnd?.()
            }
            return prev
          })
        }}
        letter={letter}
        fakes={getNRandomLetters(8).join('')}
      />
    )
  })
}

const Letter: React.FC<{
  letter: string
  fakes: string
  onShuffleEnd: () => void
}> = ({ letter, fakes, onShuffleEnd }) => {
  const [index, setIndex] = React.useState(0)
  const randomInterval = useMemo(() => Math.random() * 50 + 50, [])

  React.useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => {
        if (prev + 1 === fakes.length) {
          clearInterval(interval)
          onShuffleEnd()
        }
        return prev + 1
      })
    }, randomInterval)

    return () => clearInterval(interval)
  }, [fakes.length])

  return letter === ' ' ? letter : fakes[index] ?? letter
}
